<template lang="pug">
div
    div(slot="header").loyalty-movimientos-table__header
      filter-table(
        layout="text"
        @inputSearchFilter="inputSearchFilter")
      div
        ods-button(type="text" @click.native="detailAdvancedSearch") {{ $t('loyalty.advancedSearch') }}
    ods-table(
      v-loading="loadingTable"
      style='width: 100%'
      height="60vh"
      size="medium"
      :data='tableDataRendered')
      ods-table-column(prop='fecaltmv' :label="$t('loyalty.date')" width="100px")
        template(slot-scope="scope")
          div {{ scope.row.fecaltmv | formatDateLocale }}
      ods-table-column(prop='descccon' :label="$t('loyalty.concept')" width="200px")
        template(slot-scope="scope")
          div {{ scope.row.descccon }}
      ods-table-column(prop='punobten' :label="$t('loyalty.accumulablePointsMovements')")
        template(slot-scope="scope")
          div {{ scope.row.punobten }}
      ods-table-column(prop='punpteca' :label="$t('loyalty.avaiablePointsMovements')")
        template(slot-scope="scope")
          div {{ scope.row.punpteca }}
      ods-table-column(prop='sitactmo' :label="$t('loyalty.currentStatus')" width="250px")
        template(slot-scope="scope")
          ods-tag(v-if="scope.row.sitactmo === '01'" size="medium" color="#79C5B4") {{ $t('loyalty.accumulablePoints') }}
          ods-tag(v-if="scope.row.sitactmo === '02'" size="medium" color="#F7AC6F") {{ $t('loyalty.HeldByBlocking') }}
          ods-tag(v-if="scope.row.sitactmo === '03'" size="medium" color="#F7AC6F") {{ $t('loyalty.ManualHold') }}
          ods-tag(v-if="scope.row.sitactmo === '04'" size="medium" color="#E88AA2") {{ $t('loyalty.HeldByBlocking') }}
          ods-tag(v-if="scope.row.sitactmo === '05'" size="medium" color="#79C5B4") {{ $t('loyalty.Released') }}
          ods-tag(v-if="scope.row.sitactmo === '06'" size="medium" color="#E88AA2") {{ $t('loyalty.DefinitiveAnnulled') }}
          ods-tag(v-if="scope.row.sitactmo === '07'" size="medium" color="#79C5B4") {{ $t('loyalty.Expired') }}
          ods-tag(v-if="scope.row.sitactmo === '08'" size="medium" color="#F7AC6F") {{ $t('loyalty.Informative') }}
          ods-tag(v-if="scope.row.sitactmo === '09'" size="medium" color="#E88AA2") {{ $t('loyalty.FullyRedeemed') }}
          ods-tag(v-if="scope.row.sitactmo === '10'" size="medium" color="#E88AA2") {{ $t('loyalty.TransferredToAnotherAccount') }}
          ods-tag(v-if="scope.row.sitactmo === '11'" size="medium" color="#E88AA2") {{ $t('loyalty.CancelledAfterAutomaticAward') }}
          ods-tag(v-if="scope.row.sitactmo === '12'" size="medium" color="#E88AA2") {{ $t('loyalty.Exceeded') }}
          ods-tag(v-if="scope.row.sitactmo === '13'" size="medium" color="#E88AA2") {{ $t('loyalty.Penalized') }}
      div.footer
        paginator-table(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
    ods-dialog(
      :visible.sync="isAdvancedSearch"
      :append-to-body="true"
      :before-close="handleCloseAdvancedSearch"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      width="655px")
      div.loyalty-movimientos-table__dialog-header
        h2 {{ this.$t('loyalty.advancedSearch') }}
      ods-form.vendor-form(
        label-position='top'
        :model='advancedData'
        ref='advancedData'
        :show-message="showMessage"
        :validate-on-rule-change="validateOnRuleChange")
          .loyalty-movimientos-table__dialog-dateContent
            div.fecha-inicio
              span.ods-form-item__label {{ this.$t('loyalty.startDate') }}
            div.fecha-fin
              span.ods-form-item__label {{ this.$t('loyalty.endDate') }}
          ods-date-picker(v-model="advancedData.fechin" type="daterange" size="large" :editable="true" :clearable="true" v-on:click.native="activeIndexPicker" @change="changeDatePicker").loyalty-movimientos-table__dialog-form-picker
          .loyalty-movimientos-table__dialog-form
            ods-form-item(label="Concepto")
              ods-select(v-model="advancedData.concept"
                @change="changeConcept" :clearable="true")
                  ods-option(key="1" :label="this.$t('loyalty.automaticRedemption')" value="RA")
                  ods-option(key="2" :label="this.$t('loyalty.manualRedemption')" value="RM")
      .loyalty-movimientos-table__dialog-footer(slot='footer')
        ods-button(@click="activeAdvancedSearch(advancedData, 'advancedData')") {{ this.$t('loyalty.apply') }}
</template>
<script>
import { mapActions } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'MovimientosTable',
  props: ['cuenta'],
  data () {
    return {
      loadingTable: true,
      tableDataRendered: null,
      tableData: null,
      currentPage: null,
      indMasDatos: null,
      paginationParams: null,
      wrapStyle: {
        height: '750px'
      },
      viewClass: 'ods-scrollbar__view--custom',
      isAdvancedSearch: false,
      showMessage: true,
      validateOnRuleChange: true,
      advancedData: {},
      activeInitDate: false,
      valueFechFin: ''
    }
  },
  components: {
    'filter-table': FilterTable,
    'paginator-table': Paginator
  },
  async created () {
    const params = {
      codCuent: this.cuenta.codcuent,
      fechades: '',
      fechahas: '',
      concept: ''
    }
    await this.getData(params)
  },
  destroyed () {
    this.resetForm()
  },
  methods: {
    ...mapActions(['getMovements']),
    async getData (params) {
      this.loadingTable = true
      const response = await this.getMovements(params)
      if (response.registros && response.retorno !== 210) {
        this.tableData = Array.isArray(response.registros) ? response.registros : [response.registros]
        this.tableDataRendered = this.tableData
        this.loadingTable = false
      } else {
        this.tableData = null
        this.tableDataRendered = this.tableData
        this.loadingTable = false
      }
      this.currentPage = response.pantPagina
      this.indMasDatos = response.indMasDatos
      this.paginationParams = {
        claveInicio: response.claveInicio,
        claveFin: response.claveFin
      }
    },
    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter(obj => Object.values(obj).some(val => val.toString().toLowerCase().indexOf(text.toLowerCase()) > -1))
    },
    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true,
        codCuent: this.cuenta.codcuent
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true,
        codCuent: this.cuenta.codcuent
      }
      this.getData(params)
    },
    detailAdvancedSearch () {
      this.isAdvancedSearch = true
    },
    handleCloseAdvancedSearch () {
      this.isAdvancedSearch = false
    },
    resetForm () {
      this.advancedData = {}
    },
    formatDate (date) {
      var d = new Date(date)
      return new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000).toISOString().split('T')[0]
    },
    activeIndexPicker () {
      const picker = document.querySelector('.ods-date-range-picker')
      picker.style.zIndex = '9999'
    },
    changeDatePicker (data) {
      this.advancedData.fechin = [this.formatDate(data[0]), this.formatDate(data[1])]
    },
    changeConcept (data) {
      if (data.length > 1) {
        this.advancedData.concept = data.toString()
      } else {
        this.advancedData.concept = null
      }
    },
    async activeAdvancedSearch (data, moreData) {
      const params = {
        codCuent: this.cuenta.codcuent,
        fechades: '',
        fechahas: '',
        concept: ''
      }
      if (typeof data.concept !== 'undefined' && data.concept !== null) {
        params.concept = data.concept
        if (typeof data.fechin !== 'undefined' && data.fechin !== null) {
          params.fechades = data.fechin[0]
          params.fechahas = data.fechin[1]
        }
        this.getData(params)
      } else {
        params.concept = ''
        if (typeof data.fechin !== 'undefined' && data.fechin !== null) {
          params.fechades = data.fechin[0]
          params.fechahas = data.fechin[1]
        }
        this.getData(params)
      }
      this.isAdvancedSearch = false
      // this.resetForm()
    }
  }
}
</script>
<style lang="scss">
.loyalty-movimientos-table{
.notfound {
  margin-top: rem(28)
}

&__header{
  display: flex;
  justify-content: space-between;
}

&__footer{
  display: flex-end;
  justify-content: space-between;
}

&__dialog-header{
    display: flex;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 24px;
}

  .ods-table {
    background: #fff;
    margin: 12px 0;
  }

&__dialog-dateContent{
  display: flex;
  .fecha-fin{
  width: 36.33% !important;
  margin-left: 45px !important;
}
.fecha-inicio {
  width: 36.33% !important;
}

}

&__dialog-form-picker{
  width: 100%;
  display: flex !important;

.ods-range-separator{
  display: none !important;
}

.ods-input__inner:first-child {
  width: 36.33% !important;
  margin-right: 45px;
}

.ods-input__inner {
  width: 36.33% !important;
}

.ods-picker-panel{
  z-index: 9999 !important;
}
.ods-form-item{
  margin: 0 !important;
}
}

&__dialog-form{
  margin-top: 32px;
 .ods-select{
    width: 36.33% !important;
    max-width: 36.33% !important;
  }
}
}

/deep/ .ods-picker-panel .ods-date-range-picker .ods-popper {
z-index: 99999 !important;
}

</style>
